module.exports = __webpack_public_path__ + "media/images/diy/bg-shape-lg-f06564fdc5e189b1924bb457fdd90c17.svg";